module.exports = __webpack_public_path__ + "img/Octocat-poptocat.1a32c70d.png";